import MainContext from 'components/QuickSearch/components/context';
import { format } from 'modules/helpers/strings';
import Translations from 'modules/translations';
import { useContext } from 'react';
import styled from 'styled-components';
import { buttonEnum, layoutEnum, listTypeEnum } from '../../enums';
import ClearHistoryButton from '../shared/clearHistoryButton';
import SimpleButton from '../shared/simpleButton';

const Header = styled.div`
    display: flex;
    flex: 0 0 100%;
    background-color: #ececec;
    padding: ${({ $layout, $isHandheld }) => ($layout === layoutEnum.tab ? '10px 15px' : $isHandheld ? '5px 5px 5px 20px' : '5px 20px')};
    font-size: 12px;
    justify-content: center;
    align-items: center;
    text-align: center;
`;
const Title = styled.div`
    flex: 0 1 auto;
    font-weight: 700;
    text-transform: uppercase;
    text-align: left;
`;
const Right = styled.div`
    display: flex;
    flex: 1 0 0px;
    justify-content: flex-end;
`;
const Caption = styled.span`
    display: block;
    margin: 15px;
    font-size: 12px;
    text-align: center;
`;

const renderButton = (buttonType, buttonLinkAction, text) => {
    switch (buttonType) {
        case buttonEnum.link:
            if (!buttonLinkAction) return null;
            return <SimpleButton text={text} buttonLinkAction={buttonLinkAction} />;
        case buttonEnum.clearHistory:
            return <ClearHistoryButton text={text} />;
        default:
            return null;
    }
};

export default (props) => {
    const { buttonLinkAction, headline, captionText, buttonType, hitsShown, hitsTotal, listType } = props;
    const mainContext = useContext(MainContext);
    const { layout, isHandheld } = mainContext;

    return (
        <>
            <Header $layout={layout} $isHandheld={isHandheld}>
                <Title>
                    {headline}
                    {(listType === listTypeEnum.product || listType === listTypeEnum.article) && (
                        <span>
                            {format(Translations.Website.SearchDialog.SectionTitleSubLine)(hitsShown, hitsTotal)}
                        </span>
                    )}
                </Title>
                <Right>
                    {(hitsTotal > hitsShown || buttonType === buttonEnum.clearHistory) &&
                        renderButton(buttonType, buttonLinkAction)}
                </Right>
            </Header>
            {captionText && <Caption>{format(captionText)}</Caption>}
        </>
    );
};
